import React from 'react';
import '../css/viewMediaOverlay.css';
import CloseButton from '../../../button-fs-cp/close-button-op/ts/closeButton';
import StatusBadge, { BadgeVariant } from '../../../badge-fs-cp/dynamic-badge-op/ts/statusBadge';
import { Button } from '@core/uilibrary';
import { DownloadIcon, TrashIcon2, EditIcon } from '../../../../../asset-controller-mod/asset-serv/icons/iconExporter';

/* ── Types ───────────────────────────────────────────────── */

export interface ViewMediaOverlayProps {
  imageSrc:    string;
  fileName:    string;
  fileType:    string;
  fileSize:    string;
  uploadBy:    string;
  uploadDate:  string;
  altText:     string;
  description: string;
  status:      BadgeVariant;
  onClose?:    () => void;
  onDownload?: () => void | Promise<void>;  // ← supports async
  onDelete?:   () => void;
  onEdit?:     () => void;
    statusLabel?: string; // ✅ add
}

/* ── Detail Row ──────────────────────────────────────────── */

interface DetailRowProps {
  label:    string;
  children: React.ReactNode;
}

const DetailRow: React.FC<DetailRowProps> = ({ label, children }) => (
  <div className="scl--cms-components-viewMedia-row">
    <span className="scl--cms-components-viewMedia-label">{label}</span>
    <span className="scl--cms-components-viewMedia-value">{children}</span>
  </div>
);

/* ── Component ───────────────────────────────────────────── */

const ViewMediaOverlay: React.FC<ViewMediaOverlayProps> = ({
  imageSrc,
  fileName,
  fileType,
  fileSize,
  uploadBy,
  uploadDate,
  altText,
  description,
  status,
  onClose,
  onDownload,
  onDelete,
  onEdit,
  statusLabel, 
}) => {
  return (
    <div className="scl--cms-components-viewMedia-modal">

      {/* ── Header ── */}
      <div className="scl--cms-components-viewMedia-header">
        <h2 className="scl--cms-components-viewMedia-title">File Detail</h2>
        <div className="scl--cms-components-viewMedia-closeBtn">
          <CloseButton onClick={onClose} aria-label="Close file detail" />
        </div>
      </div>

      {/* ── Body ── */}
      <div className="scl--cms-components-viewMedia-body">

        {/* ── Left Panel ── */}
        <div className="scl--cms-components-viewMedia-left">

          {/* Image preview */}
          <div className="scl--cms-components-viewMedia-imageWrapper">
            <img
              src={imageSrc}
              alt={altText}
              className="scl--cms-components-viewMedia-image"
            />
          </div>

          {/* Actions */}
          <div className="scl--cms-components-viewMedia-actions">
            <Button variant="ghost" icon={<DownloadIcon />} value="Download File" onClick={onDownload} />

            <div className="scl--cms-components-viewMedia-actionDivider" />
            <Button variant="danger" icon={<TrashIcon2 />} value="Delete" className="scl--cms-component-viewMedia-button-danger" onClick={onDelete} />
          </div>

        </div>

        {/* ── Vertical Divider ── */}
        <div className="scl--cms-components-viewMedia-divider" />

        {/* ── Right Panel ── */}
        <div className="scl--cms-components-viewMedia-right">

          <div className="scl--cms-components-viewMedia-editBtn">
            <Button icon={<EditIcon />} value='' variant="ghost" onClick={onEdit} />
          </div>
          

          {/* Detail rows */}
          <div className="scl--cms-components-viewMedia-details">
            <DetailRow label="File name :">
              {fileName}
            </DetailRow>
            <DetailRow label="Type :">
              {fileType}
            </DetailRow>
            <DetailRow label="Size :">
              {fileSize}
            </DetailRow>
            <DetailRow label="Upload by :">
              {uploadBy}
            </DetailRow>
            <DetailRow label="Upload date :">
              {uploadDate}
            </DetailRow>
            <DetailRow label="Alt text :">
              {altText}
            </DetailRow>
            <DetailRow label="Status :">
              <StatusBadge variant={status} label={statusLabel} /> 
            </DetailRow>
            <DetailRow label="Description:">
              {description}
            </DetailRow>
          </div>

        </div>
      </div>

      {/* ── Footer ── */}
      <div className="scl--cms-components-viewMedia-footer">
        <Button
          value="Back"
          variant="ghost"
          size="md"
          onClick={onClose}
        />
      </div>

    </div>
  );
};

export default ViewMediaOverlay;